import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListBrand from "./views/listBrand";
import CreateBrand from "./views/createBrand";
import EditBrand from "./views/editBrand";
import ViewBrand from "./views/viewBrand";
import "../../../style.scss";

function Brand(props) {
  const params = useParams();
  const location = useLocation();

  const title = "Manage Brands | Chimera Solutions | Insights";
  const routes = [
    {
      name: "list",
      component: ListBrand,
    },
    {
      name: "create",
      auth: true,
      level: [0, 1],
      component: CreateBrand,
    },
    {
      name: "edit",
      path: "/edit",
      auth: true,
      level: [0, 1],
      component: EditBrand,
    },
    {
      name: "view",
      component: ViewBrand,
    },
  ];

  let Error = props.components.setting[0].component;
  let Component = <Error />;
  let showComponent = false;

  if (params.page) {
    const route = routes.find((route) => {
      if (route.name === params.page) {
        if (route.auth) {
          return route.level.includes(props.user.data.level);
        }
        return true;
      }
      return false;
    });

    showComponent = true;

    if (route) {
      const RouteComponent = route.component;
      Component = (
        <RouteComponent
          match={{ params }}
          user={props.user}
          chimeraserv={props.chimeraserv}
          components={props.components}
        />
      );
    }
  }

  const basePath = location.pathname.split("/").slice(0, 4).join("/");

  return (
    <div className="viewContainer">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div
        className="heading"
        style={{
          justifyContent: "flex-end",
          marginBottom: "10px",
          padding: "12px",
        }}
      >
        {[0, 1].includes(props.user.data.level) ? (
          <Link to={`${basePath}/create`}>
            <FontAwesomeIcon className="icon" icon={["fas", "plus"]} /> Create
            New Brand
          </Link>
        ) : (
          <div />
        )}
        <Link to={`${basePath}/list`}>List of Brands</Link>
      </div>
      <div className="viewBody">
        {showComponent ? (
          Component
        ) : (
          <ListBrand
            match={{ params }}
            user={props.user}
            chimeraserv={props.chimeraserv}
            components={props.components}
          />
        )}
      </div>
    </div>
  );
}

export default Brand;
